// The Spraytan Queen — academy page-specific behavior

// ─── FAQ ───
document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
        const item = btn.parentElement;
        const wasOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(i => {
            i.classList.remove('open');
            i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
            item.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
        }
    });
});

// Contact form submission is now handled natively by Shopify's {% form 'contact' %}
// (server-side, no JS needed — see sections/academy-cta.liquid).
